import { useMediaQuery, useTheme } from "@mui/material";
import React, { createContext, useContext, useEffect, useState } from "react";

const MenuContext = createContext<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}>({ isOpen: false, setIsOpen: () => {} });

export const MenuProvider = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const isDownLg = useMediaQuery(theme.breakpoints.up('md'));
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isDownLg);
  }, [isDownLg]);
  
  return (
    <MenuContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
